import { render, staticRenderFns } from "./DoctorsActivity.vue?vue&type=template&id=6a800aef&"
import script from "./DoctorsActivity.vue?vue&type=script&lang=ts&"
export * from "./DoctorsActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports